export const FAQ_ITEMS = [
  {
    id: 'urgence',
    question: 'Intervenez-vous en urgence ?',
    answer: [
      'Oui. Nous intervenons pour les situations d’urgence en plomberie et faisons notre maximum pour vous proposer une intervention dans les meilleurs délais, en fonction de votre localisation et de la disponibilité de nos équipes.',
    ],
  },
  {
    id: 'prix-avance',
    question: 'Le prix de la prestation est-il connu à l’avance ?',
    answer: [
      'Oui, toujours. Le prix applicable vous est communiqué avant la validation de votre commande. Pour les prestations dont le tarif est déterminé à l’avance, vous connaissez directement le prix avant de commander. Lorsque la nature ou l’étendue des travaux nécessite une évaluation préalable, un devis vous est soumis avant toute intervention.',
      'Aucune intervention n’est réalisée sans que son prix, ou les modalités de détermination de celui-ci, vous ait été clairement communiqué au préalable.',
    ],
  },
  {
    id: 'devis-gratuit',
    question: 'Le devis est-il gratuit ?',
    answer: [
      'Oui, lorsque l’établissement d’un devis est nécessaire. Certaines prestations peuvent être réalisées sur la base d’un tarif connu à l’avance et ne nécessitent donc pas de devis. Lorsqu’un devis est nécessaire, celui-ci est établi avant le début des travaux.',
    ],
  },
  {
    id: 'types-prestations',
    question: 'Quels types de prestations réalisez-vous ?',
    answer: [
      'Nous intervenons pour de nombreuses prestations de plomberie, notamment les fuites d’eau, débouchages de canalisations, problèmes de robinetterie, chauffe-eau, WC, éviers, douches et baignoires, ainsi que pour les travaux d’installation, de remplacement, de réparation et de rénovation de plomberie.',
    ],
  },
  {
    id: 'particuliers-pros',
    question: 'Intervenez-vous auprès des particuliers et des professionnels ?',
    answer: [
      'Oui. Nous intervenons aussi bien auprès des particuliers que des professionnels, notamment les entreprises, commerces, copropriétés et collectivités.',
    ],
  },
  {
    id: 'garanties',
    question: 'Vos interventions sont-elles garanties ?',
    answer: [
      'Oui. Nos prestations sont réalisées conformément aux règles de l’art et bénéficient des garanties légales applicables, selon la nature des travaux réalisés.',
    ],
  },
  {
    id: 'commander',
    question: 'Comment puis-je commander une intervention ?',
    answer: [
      'La commande s’effectue en ligne. Le prix de la prestation vous est communiqué avant la validation de la commande et le paiement est effectué en ligne au moment de celle-ci. Une fois le paiement confirmé, votre intervention peut être planifiée.',
    ],
  },
  {
    id: 'annuler',
    question: 'Puis-je annuler une intervention ?',
    answer: [
      'Oui, sous réserve des conditions d’annulation applicables. Une annulation effectuée suffisamment à l’avance n’entraîne aucun frais. Des frais peuvent être appliqués en cas d’annulation tardive ou d’absence au rendez-vous, selon le délai précédant l’intervention.',
      [
        { type: 'text', text: 'Les conditions et montants applicables sont précisés dans nos ' },
        { type: 'link', href: '/cgv#retractation-annulation', text: 'conditions générales' },
        { type: 'text', text: '.' },
      ],
    ],
  },
];
